import api from '@/services/apiService';

export interface MMRHistoryItem {
  id: number;
  date: string;
  title: string;
  outcomeText: string;
  outcomeStatus: 'win' | 'draw' | 'loss';
  deltaMMR: number;
  eventSlug?: string;
  gameSlug?: string;
}

export interface ClientMMRProfile {
  mmr: number;
  tier: 'Bronze' | 'Silver' | 'Gold' | 'Master' | 'Elite' | 'Immortal';
  nextTier: 'Bronze' | 'Silver' | 'Gold' | 'Master' | 'Elite' | 'Immortal';
  targetMMR: number;
  neededMMR: number;
  tierMinMMR?: number;
  rankDisplay?: string;
  delta30Days: number;
  pointsGained30Days?: number;
  winDrawMatches30Days?: number;
  pointsLost30Days?: number;
  lossMatches30Days?: number;
  totalMatches30Days?: number;
  avgDeltaPerMatch30Days?: number;
  highestDelta30Days?: number;
  totalMatches: number;
  totalWins: number;
  totalDraws: number;
  totalLosses: number;
  winrate: string;
  totalGoals: number;
  totalAssists: number;
  history?: MMRHistoryItem[];
}

export interface MMRProfileResponse {
  success: boolean;
  data: ClientMMRProfile;
}

export interface LeaderboardItem {
  rank: number;
  userId: number;
  name: string;
  username: string;
  avatar?: string;
  tier: string;
  position?: string;
  matches: number;
  mmr: number;
  rankChange: string;
  isCurrentUser?: boolean;
}

export interface MMRLeaderboardResponseData {
  top3: LeaderboardItem[];
  rankings: LeaderboardItem[];
  currentUser?: LeaderboardItem;
  diffNextText?: string;
}

export interface LeaderboardApiResponse {
  success: boolean;
  data: MMRLeaderboardResponseData;
}

export const mmrService = {
  getClientMMRProfile: async (sportCategory: string = 'minisoccer'): Promise<MMRProfileResponse> => {
    const response = await api.get(`/client/mmr?sportCategory=${sportCategory}`);
    return response.data;
  },

  getLeaderboard: async (
    position: string = '',
    sportCategory: string = 'invasion',
    options: { public?: boolean } = {}
  ): Promise<LeaderboardApiResponse> => {
    const params = new URLSearchParams();
    if (sportCategory) params.append('sportCategory', sportCategory);
    if (position) params.append('position', position);
    const path = options.public ? '/public/mmr/leaderboard' : '/client/mmr/leaderboard';
    const response = await api.get(`${path}?${params.toString()}`);
    return response.data;
  },

  getInvasionSession: async (eventSlug: string) => {
    const response = await api.get(`/mabar/events/${eventSlug}/invasion`);
    return response.data;
  },
};

export default mmrService;
